import { atom, useAtom } from "jotai";

export type ComboType = "orderbook" | "rfq-options";

export const comboTypeAtom = atom<ComboType>("orderbook");

export const useComboType = () => {
  const [comboType, setComboType] = useAtom(comboTypeAtom);

  const isComboOrderBook = comboType === "orderbook";
  const isComboRFQ = comboType === "rfq-options";

  return {
    isComboOrderBook,
    isComboRFQ,
    comboType,
    setComboType,
  };
};
